import { getGoogleMapApiKey } from '@northladder/utilities';

import {
  IGooglePlacesParams,
  IGooglePlacesDetailsParams,
  IGoogleReverseGeocodeParams,
} from '../maps-api/types';

/**
 * Endpoint used for fetching the Google Places autocomplete results.
 * @param searchKey - The search key to be used for the autocomplete query.
 * @param language - The language code for the results.
 */
export const googleMapsPlacesUrl = ({
  searchKey,
  language,
}: IGooglePlacesParams) => {
  const API_KEY = getGoogleMapApiKey();
  return `/place/autocomplete/json?input=${encodeURIComponent(
    searchKey
  )}&language=${language}&key=${API_KEY}`;
};

/**
 * Endpoint used for fetching the Google Place details by place ID.
 * @param placeId - The unique identifier for the place.
 * @param language - The language code for the results.
 */
export const googleMapsPlaceDetailsUrl = ({
  placeId,
  language,
}: IGooglePlacesDetailsParams) => {
  const API_KEY = getGoogleMapApiKey();
  return `/place/details/json?place_id=${placeId}&language=${language}&key=${API_KEY}`;
};

/**
 * Endpoint used for reverse geocoding (getting address from coordinates).
 * @param lat - The latitude coordinate.
 * @param lng - The longitude coordinate.
 * @param language - The language code for the results.
 */
export const googleMapsReverseGeocodeUrl = ({
  lat,
  lng,
  language,
}: IGoogleReverseGeocodeParams) => {
  const API_KEY = getGoogleMapApiKey();
  return `/geocode/json?latlng=${lat},${lng}&language=${language}&key=${API_KEY}`;
};
